import React from 'react';
import PropTypes from 'prop-types';
import NagivationBar from './NavigationBar';
import Footer from './Footer';
import LoginModal from '../modals/LoginModal';
import SignUpModal from '../modals/SignUpModal';
import ForgotPasswordModal from '../modals/ForgotPasswordModal';
import UserAgreementModal from '../modals/UserAgreementModal';


const Navigation = ({children}) => {
  return (
    <div className="page-wrapper">
      <nav>
        <NagivationBar/>
      </nav>
      <main>
        {children}
        <LoginModal/>
        <SignUpModal/>
        <ForgotPasswordModal/>
        <UserAgreementModal/>
      </main>
      <footer>
        <Footer/>
      </footer>
    </div>
  );
};

Navigation.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// /src/components/navigation/Navigation.jsx